import { type ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { generateDataItem } from '@app/helpers';
import { type ArtifactCount, artifactKeyToUrlMap } from '@app/store/types/artifacts';

export function artifactCountsSelector(state) {
    const artifacts = state.artifacts.artifacts;

    const artifactSupplyCounts: ArtifactCount = {};
    artifacts &&
        artifacts.forEach((artifact) => {
            const remainingSupply = artifact.total - (artifact.available_total + artifact.consumed_total);
            artifactSupplyCounts[artifact.artifact_type] = {
                total: artifact.total,
                consumed_total: artifact.consumed_total,
                available_total: artifact.available_total,
                remaining_supply: remainingSupply,
            };
        });

    return artifactSupplyCounts;
}

export function userArtifacts(state) {
    const userBreakdown = state.artifacts.userArtifacts;
    const displayArtifactKeyArray: ArtifactType[] = [...artifactKeyToUrlMap.keys()];
    const collectedKeys: ArtifactType[] = [];

    userBreakdown &&
        Object.keys(userBreakdown).forEach((type) => {
            const typeBreakdown = userBreakdown[type];
            const allOwnerAssetIds = generateDataItem().ownedIds(typeBreakdown);

            if (allOwnerAssetIds?.length > 0) {
                collectedKeys.push(type as ArtifactType);
            } else {
                uncollectedKeys.push(type as ArtifactType);
            }
        });

    const uncollectedKeys: ArtifactType[] = displayArtifactKeyArray.filter((key) => !collectedKeys.includes(key));

    const byType = (a, b) => displayArtifactKeyArray.indexOf(a) - displayArtifactKeyArray.indexOf(b);
    const totalKeys = [...collectedKeys.sort(byType), ...uncollectedKeys.sort(byType)];

    return {
        displayArtifactKeyArray,
        collectedKeys,
        uncollectedKeys,
        totalKeys,
    };
}
